export const ASSIGNMENT_STATUS_MASTERED = 'mastered';
